import React, { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

// Define keyframes for animations directly in JS for simplicity here
// Or consider moving to a CSS file for larger applications
const keyframesStyle = `
  @keyframes pump {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(4px); }
  }
  @keyframes glow {
    0%, 100% { text-shadow: 0 0 5px var(--color-primary), 0 0 10px var(--color-primary); }
    50% { text-shadow: 0 0 8px var(--color-primary), 0 0 15px var(--color-primary); }
  }
`;

function ScrollIndicator() {
  // Inject keyframes into the document head
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = keyframesStyle;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet); // Clean up on unmount
    };
  }, []);

  // Define styles
  const indicatorStyle = {
    position: 'relative',
    marginTop: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.2rem',
    cursor: 'pointer',
    color: 'var(--color-primary)',
    textShadow: '0 0 5px var(--color-primary)',
    animation: 'glow 2s infinite ease-in-out',
  };

  const chevronStyle = {
    animation: 'pump 1.5s infinite ease-in-out',
  };

  // Scroll down smoothly when clicked
  const handleClick = () => {
    window.scrollTo({
      top: window.innerHeight * 0.9,
      behavior: 'smooth'
    });
  };

  return (
    <div 
      style={indicatorStyle} 
      onClick={handleClick} 
      title="Scroll Down"
    >
      Scroll
      <ChevronDown size={28} style={chevronStyle} />
    </div>
  );
}

export default ScrollIndicator; 
 
 
 